import {useCallback, useState} from 'react';

import {USER_NOT_FOUND_MESSAGE} from 'src/constants';
import {getUserById} from 'src/openapi/admin/apis/UserIdentityApi';
import {useAppDispatch} from 'src/store';

import type {User} from 'src/openapi/admin/models/User';

type Return = {
    lookupUserById: (userId: number) => Promise<User | null>,
    loading: boolean,
    error: string | null,
    clearError: () => void,
};

export const useUserLookup = (): Return => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const lookupUserById = useCallback(async (userId: number): Promise<User | null> => {
        setLoading(true);
        setError(null);

        try {
            const res = await dispatch(getUserById({userId}));
            const user = res.payload?.success ? (res.payload.data as User | undefined) : undefined;

            if (!user) {
                setLoading(false);
                setError(USER_NOT_FOUND_MESSAGE);
                return null;
            }

            setLoading(false);
            return user;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            setError(message);
            setLoading(false);
            return null;
        }
    }, [dispatch]);

    const clearError = useCallback(() => setError(null), []);

    return {lookupUserById, loading, error, clearError};
};
